import { useCallback } from 'react';
import { useFlatCountryOptions } from '~/hooks/bookingFlow/useCountryOptions';
import useStateOptions from '~/hooks/bookingFlow/useStateOptions';
import useTranslation from '~/hooks/useTranslation';
import addressInformationStyles from '~/styles/bookingFlow/address-information.module.css';
import { PackageInformationRequest } from '~/types/api';

type Props = {
  address: PackageInformationRequest['address'];
};

export default function SummaryAddressInformation({
  address,
}: Props) {
  const translate = useTranslation();
  const countryOptions = useFlatCountryOptions();
  const stateOptions = useStateOptions();

  const countryLabelForIso = useCallback((iso: string) => {
    return countryOptions.find((country) => country.value === iso)?.label;
  }, [countryOptions]);

  const stateLabelForCode = useCallback((code: string) => {
    return stateOptions.find((state) => state.value === code)?.label;
  }, [stateOptions]);

  return (
    <>
      <h2 className={addressInformationStyles.addressInformationHeading}>
        {translate('bookingFlow.summary.address_information_title')}
      </h2>

      <ul className={addressInformationStyles.addressInformationList}>
        {address?.street && (
          <li>
            {`${address?.street} ${address?.housenum || ''}`}
          </li>
        )}
        {address?.address_line_2 && (
          <li>
            {address?.address_line_2}
          </li>
        )}
        {address?.city && (
          <li>
            {address?.city}
          </li>
        )}
        {address?.state && (
          <li>
            {stateLabelForCode(address?.state)}
          </li>
        )}
        {address?.postal_code && (
          <li>
            {address?.postal_code}
          </li>
        )}
        {address?.country && (
          <li>
            {countryLabelForIso(address?.country)}
          </li>
        )}
      </ul>
    </>
  );
}
